import { render, staticRenderFns } from "./SectionDocumentsList.vue?vue&type=template&id=34fe5d51&scoped=true&"
import script from "./SectionDocumentsList.vue?vue&type=script&lang=ts&"
export * from "./SectionDocumentsList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionDocumentsList.vue?vue&type=style&index=0&id=34fe5d51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe5d51",
  null
  
)

export default component.exports